import { render, staticRenderFns } from "./StoreEvent.vue?vue&type=template&id=08434c45&scoped=true"
import script from "./StoreEvent.vue?vue&type=script&lang=js"
export * from "./StoreEvent.vue?vue&type=script&lang=js"
import style0 from "./StoreEvent.vue?vue&type=style&index=0&id=08434c45&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08434c45",
  null
  
)

export default component.exports